{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dhuhr",
    "Asr": "Asr",
    "Maghrib": "Maghrib",
    "Isha": "Isha"
  },
  "card": {
    "label": "Next Prayer",
    "labelTomorrow": "Tomorrow · {{prayer}}",
    "inHoursMinutes": "in {{hours}}h {{minutes}}m",
    "inMinutes": "in {{minutes}}m",
    "open_aria": "Open prayer times",
    "pro": "Rhemn Pro",
    "unlock_aria": "Unlock prayer times with Rhemn Pro",
    "unavailable": "Prayer times unavailable right now."
  },
  "sheet": {
    "bellOn_aria": "Turn off the {{prayer}} reminder",
    "bellOff_aria": "Turn on the {{prayer}} reminder",
    "explainer": "Get a gentle reminder at each prayer. Reminders are silent notifications — no sound by default.",
    "enableReminders": "Enable reminders",
    "enableInSettings": "Enable notifications for Rhemn in Settings to get prayer reminders.",
    "openSettings": "Open Settings"
  },
  "notifications": {
    "body": "It's time to pray."
  },
  "focus": {
    "label": "{{prayer}} Prayer",
    "close_aria": "Close prayer screen",
    "hint": "Press Esc or × to return",
    "phrases": {
      "accepted": "May Allah accept your prayer",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Begin with intention. Continue with barakah.",
    "prayerApproaches": "Your next prayer approaches. Stay anchored in your intention.",
    "morningPursue": "A blessed morning to pursue: {{focus}}",
    "dayCloses": "As the day closes, reflect on: {{focus}}",
    "fulfilled": "You fulfilled your intention today. Alhamdulillah.",
    "workingTowards": "Today you are working towards: {{focus}}",
    "prayerNear": "Your next prayer is near. Take a breath."
  },
  "widget": {
    "countdown": "in {{time}}",
    "openToUpdate": "Open Rhemn to update",
    "openForVerse": "Open Rhemn for today’s verse"
  }
}
